import { render, staticRenderFns } from "./default.vue?vue&type=template&id=3a6bb1e5&scoped=true&"
import script from "./default.vue?vue&type=script&lang=js&"
export * from "./default.vue?vue&type=script&lang=js&"
import style0 from "./default.vue?vue&type=style&index=0&id=3a6bb1e5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a6bb1e5",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiGlobalLoader: require('/app/components/UI/UiGlobalLoader.vue').default})
